import React, { useState } from "react";
import ToggleSwitch from "../../components/ToggleSwitch/ToggleSwitch";
import AddOrEditSalaryMapping from "./AddOrEditSalaryMapping";
import { useViewSalaryComponents, useUpdatePayrollPolicyActiveStatus } from "../../queries/payrollQuries";
import { toast } from "react-toastify";

const SalaryEarningListData = ({ payrollPolicyList }) => {
  const [isActive, setIsActive] = useState(payrollPolicyList?.is_active || false);
  const [openModal, setOpenModal] = useState(false);
  const [salaryComponentsData, setSalaryComponentsData] = useState([]);
  const [toggleLoading, setToggleLoading] = useState(false);

  const { refetch: fetchSalaryComponents } = useViewSalaryComponents();
  const updateStatusMutation = useUpdatePayrollPolicyActiveStatus();

  const handleEditClick = async () => {
    try {
      const { data } = await fetchSalaryComponents(); 
      setSalaryComponentsData(data?.data || []);
      setOpenModal(true);
    } catch (error) {
      console.error("Failed to fetch salary components", error);
    }
  };

  const handleToggle = (newStatus) => {
   
    const policyId = payrollPolicyList?.id;
    setIsActive(newStatus);
    setToggleLoading(true); 
  
    updateStatusMutation.mutate(
      { policy_id: policyId, is_active: newStatus },
      {
        onSuccess: (data) => {
          setToggleLoading(false); 
          if (data?.status) {
            toast.success(data?.message || "Status updated successfully");
          } else {
            toast.error(data?.message || "Failed to update status");
          }
        },
        onError: (error) => {
          setToggleLoading(false); 
          toast.error(error?.response?.data?.message || "Something went wrong");
        },
      }
    );
  };
  

  return (
    <>
      <tr className="bg-white border-b hover:bg-gray-50 dark:hover:bg-gray-200">
        <td className="px-10 py-4 text-blue-700 font-medium">
          {payrollPolicyList?.policy_name}
        </td>
        <td className="px-10 py-4">{payrollPolicyList?.description || "-"}</td>
        <td className="px-10 py-4">
          <span className="py-1 px-2.5">
          <ToggleSwitch
  checked={isActive}
  getToggleState={handleToggle}
  disabled={toggleLoading} 
/>

          </span>
        </td>
        <td className="py-4 flex items-center justify-center gap-5 border-none">
          <img
            src="/images/edit-black-icon.svg"
            alt="Edit"
            className="cursor-pointer"
            onClick={handleEditClick}
          />
        </td>
      </tr>

      {openModal && (
        <AddOrEditSalaryMapping
          openModal={openModal}
          onCloseModal={() => setOpenModal(false)}
          policyData={payrollPolicyList}
          salaryComponentsData={salaryComponentsData}
        />
      )}
    </>
  );
};

export default SalaryEarningListData;
